<template>
  <div class="articles-page">
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          
        </div>
      </div>
    </section>

    <section class="articles">
      <div class="container">
        <div class="article-list">
          <div class="article" v-for="(article, index) in articles" :key="index" @click="navigateToArticle(article.id)">
            <img :src="article.imageSrc" :alt="article.altText" />
            <div class="article-content">
              <h2>{{ article.title }}</h2>
              <div class="read-more">
                Read More <span class="arrow">→</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="newsletter">
      <div class="container">
        <h2>Stay Updated</h2>
        <p>Subscribe to our newsletter for the latest insights and resources delivered to your inbox.</p>
        <form class="newsletter-form">
          <input type="email" placeholder="Your email address" />
          <button type="submit">Subscribe</button>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ArticlesPage',
  data() {
    return {
      articles: [
        {
          id: 'gpt-realtime',
          imageSrc: require('@/assets/images/1.png'),
          altText: 'OpenAI GPT-realtime',
          title: 'OpenAI Launches New Voice Model GPT-realtime: Creating More Natural Voice AI Agents!',
          link: '/article/gpt-realtime'
        },
        {
          id: 'plague-incident',
          imageSrc: require('@/assets/images/2.png'),
          altText: '2',
          title: "Apple's FastVLM Debuts: 85x Faster Real-Time Captioning, Limits Remain",
          link: '/article/plague-incident'
        },
        {
          id: 'article-3',
          imageSrc: require('@/assets/images/3.png'),
          altText: '3',
          title: "Top 5 AI-Powered Coding Platforms Revolutionizing Web3 Development",
          link: '/article/article-3'
        },
        {
          id: 'article-4',
          imageSrc: require('@/assets/images/4.png'),
          altText: '4',
          title: "NVIDIA’s Spectrum-XGS Ethernet Aims to Solve AI Data Centre Space Crunch",
          link: '/article/article-4'
        },
        {
          id: 'article-5',
          imageSrc: require('@/assets/images/5.png'),
          altText: '5',
          title: "Snowflake’s AI Platform Accelerates Automotive Innovation‌‌——Data Cloud Solutions Empower EV Makers with Unified Data and Digital Mobility",
          link: '/article/article-5'
        },
        {
          id: 'article-6',
          imageSrc: require('@/assets/images/6.png'),
          altText: '6',
          title: "Adobe Redefines PDF with Generative AI, Marking End of Chatbot-Free Software Era",
          link: '/article/article-6'
        },
        {
          id: 'article-7',
          imageSrc: require('@/assets/images/7.png'),
          altText: '7',
          title: "NVIDIA Unveils Blackwell-powered Enterprise GPU Solutions",
          link: '/article/article-7'
        },
        {
          id: 'article-8',
          imageSrc: require('@/assets/images/8.png'),
          altText: '8',
          title: "Deep Cogito Unveils v2 Open-Source AI Models with Enhanced Reasoning Capabilities",
          link: '/article/article-8'
        },
        {
          id: 'article-9',
          imageSrc: require('@/assets/article9.jpg'),
          altText: '9',
          title: "Anthropic Launches Claude Opus 4.5: AI Coding and Task Processing Reach New Heights",
          link: '/article/article-9'
        },
        {
          id: 'article-10',
          imageSrc: require('@/assets/article10.jpg'),
          altText: '10',
          title: "DeepSeek V3.2: Frontier AI Performance Achieved with Fractional Computing Resources",
          link: '/article/article-10'
        },
           {
          id: 'article-11',
          imageSrc: require('@/assets/article11.jpg'),
          altText: '11',
          title: "EY and NVIDIA Collaborate to Advance Physical AI Applications: Technical Insights and Industry Implications",
          link: '/article/article-11'
        },
         {
          id: 'article-12',
          imageSrc: require('@/assets/article12.jpg'),
          altText: '12',
          title: "How a Small Model Outperforms GPT-5 via Tool Coordination",
          link: '/article/article-12'
        },
         {
          id: 'article-13',
          imageSrc: require('@/assets/article13.jpg'),
          altText: '13',
          title: "Google SynthID Detector: The \"Digital ID\" Verifier for Multimodal AIGC",
          link: '/article/article-13'
        }

      ]
    };
  },
  methods: {
    navigateToArticle(id) {
      this.$router.push(`/article/${id}`);
    }
  }
};
</script>

<style scoped>
.hero {
  background-image: url('../assets/无国界切图/Insights\ and\ Discoveries.png');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0;
  text-align: center;
  position: relative;
  width: 100%;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  padding: 0 1rem;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero p {
  font-size: 1.2rem;
}

.articles {
  background-color: black;
  color: white;
  padding: 6rem 0;
  width: 100%;
}

.article-list {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 1rem;
}

.article {
  display: flex;
  align-items: stretch;
  border-radius: 8px;
  overflow: hidden;
  background-color: #1a1a1a;
  transition: transform 0.3s ease;
  cursor: pointer;
  flex-wrap: wrap;
}

.article:hover {
  transform: translateY(-2px);
}

.article img {
  width: 300px;
  height: auto;
  object-fit: cover;
  border-radius: 8px 0 0 8px;
}

.article-content {
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  position: relative;
  padding-bottom: 4rem; /* Make space for the button */
}

.article-content h2 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: white;
}

.read-more {
  position: absolute;
  bottom: 1.5rem;
  right: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--primary-color, #3498db);
  font-weight: 600;
  font-size: 1rem;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.3s ease;
}

.article:hover .read-more {
  opacity: 1;
  transform: translateX(0);
}

.read-more .arrow {
  transition: transform 0.3s ease;
}

.article:hover .read-more .arrow {
  transform: translateX(5px);
}

.newsletter {
  background-color: var(--bg-light);
  color: black;
  padding: 6rem 0;
  text-align: center;
  width: 100%;
}

.newsletter h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.newsletter p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}

.newsletter-form {
  display: flex;
  max-width: 500px;
  margin: 0 auto;
  padding: 0 1rem;
}

.newsletter-form input {
  flex: 1;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px 0 0 4px;
  font-size: 1rem;
  min-width: 0;
}

.newsletter-form button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.newsletter-form button:hover {
  background-color: var(--secondary-color);
}

@media (max-width: 768px) {
  .article {
    flex-direction: column;
  }
  
  .article img {
    width: 100%;
    height: 200px;
    border-radius: 8px 8px 0 0;
  }
  
  .hero h1 {
    font-size: 2rem;
  }
}
</style>

